import clsx from 'clsx'
import React, {useRef} from 'react'
import Box from '@mui/material/Box'
import HtmlEditor from '../components/editable-html'
import useStyles from './open-question/styles'

export default function OpenQuestion ({context, question, onPropertyChange, updateProperties}) {

  const {translate, quizQuestions = {}} = context
  const classes = useStyles()
	const answerEditor = useRef(null)
	const config = {readonly: false}
  const premiseText = question.premise.html || ''
  const answerText = question.answer.html || ''
	
  function handlePremiseChanged (html, textpremise) {
    const premise = {html}
    updateProperties && updateProperties({id: question.id, premise, textpremise}, {premise: {$set: premise}, textpremise: {$set: textpremise}})
  }

  function handleAnswerChanged (html) {
    onPropertyChange('answer', {html})
  }
	
  return (
    <Box className={clsx(classes.root, "question", "true-or-false")}>
      <Box className={clsx(classes.premise, "premise")}>
        <Box className="label">{translate('question')}:</Box>
        <HtmlEditor
          context={context}
          html={premiseText}
          onChange={handlePremiseChanged}
        />
      </Box>
      <Box className={clsx(classes.answer, "answer")}>
        <Box className="label">{translate('suggested-answer')}:</Box>
        <HtmlEditor
          context={context}
          html={answerText}
          onChange={handleAnswerChanged}
        />
     </Box>
    </Box>
  )
}
